import { RequestKind, boolean } from '@sb/library/base';
import { DisplayItemCollection, TestWebhookInputItem, WebhookDisplayItem, WebhookInputItem, WebhookSearchOptions, WebhookUpdateItem } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace WebhooksRoutes {
    export const Get = ApiRoute.Define({
        URL: (webhookID: string) => `webhooks/${webhookID}`,
        Kind: RequestKind.Get,
        ResultType: WebhookDisplayItem
    });

    export const GetAll = ApiRoute.Define({
        URL: (webhookID: string) => `webhooks`,
        Kind: RequestKind.Get,
        ResultType: DisplayItemCollection<WebhookDisplayItem>
    });

    export const Search = ApiRoute.Define({
        URL: `search/webhooks`,
        Kind: RequestKind.Post,
        BodyType: WebhookSearchOptions,
        PagingAllowed: true,
        ResultType: DisplayItemCollection<WebhookDisplayItem>
    });

    export const Add = ApiRoute.Define({
        URL: `webhooks`,
        Kind: RequestKind.Post,
        BodyType: WebhookInputItem,
        ResultType: boolean
    });

    export const Update = ApiRoute.Define({
        URL: (id: string) => `webhooks/${id}`,
        Kind: RequestKind.Put,
        BodyType: WebhookUpdateItem,
        ResultType: boolean
    });

    export const Test = ApiRoute.Define({
        URL: (id: string) => `webhooks/${id}/test`,
        Kind: RequestKind.Post,
        BodyType: TestWebhookInputItem,
        ResultType: boolean
    });

    export const Delete = ApiRoute.Define({
        URL: (id: string) => `webhooks/${id}`,
        Kind: RequestKind.Delete,
        ResultType: boolean
    });
}
